export const normalRtp = '96'
export const certificationRtp = '96.15'

export const xinStarFpId = 179
export const xinStarRtp = '98.5'
export const xinStarCurrency = 'VCPTWD'
